import CartDisclaimer from './CartDisclaimer'

export default CartDisclaimer
